import { InjectionToken } from '@angular/core';

export type SubscribeHandler = (loadingCallback?: (loading: boolean) => void) => void;
export type CloseHandler = () => void;

export const SUBSCRIBE_HANDLER_TOKEN = new InjectionToken<SubscribeHandler>(
  'SUBSCRIBE_HANDLER_TOKEN',
);

export const CLOSE_HANDLER_TOKEN = new InjectionToken<CloseHandler>('CLOSE_HANDLER_TOKEN');
